import Client from "./client";

const catalogUrl = `/api/1/markets/catalog`;

function marketsApi() {
  return {
    getCatalog: () => Client.getWithoutLoading(catalogUrl),
  };
}

export default marketsApi();
